import React, { Component }  from 'react';
import { Button, Grid, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class StopModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            amountProduced: 0
        };
        this.handleChangeAmountProduced = this.handleChangeAmountProduced.bind(this);
    }

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if(code === 13) { 
            this.props.stopOrderStep(this.state.amountProduced)
        } 
    }

    handleChangeAmountProduced(event) {
        this.setState({ amountProduced: event.target.value});
    }

    render() {
        return <Dialog open={this.props.visible} onClose={this.props.handleCloseStopDialog} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title"><Trans>{t('AmountHandled')}</Trans></DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <DialogContentText className="labelForTextbox">
                                    <Trans>{t('QuantityProducedLabel')}</Trans>
                                </DialogContentText>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    type="number"
                                    value={this.state.amountProduced}
                                    InputProps={{ inputProps: { min: 0} }}
                                    onChange={this.handleChangeAmountProduced}
                                    onKeyPress={this.enterPressed.bind(this)}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={() => this.props.stopOrderStep(this.state.amountProduced)}>
                            <Trans>{t('Ok')}</Trans>
                        </Button>
                        <Button variant="contained" color="secondary" onClick={this.props.handleStopModalCancel}>
                            <Trans>{t('Cancel')}</Trans>
                        </Button>
                    </DialogActions>
                </Dialog>
    }
}

export default StopModal;